import { SVGProps } from "react"

export default function LoginIcon(props: SVGProps<SVGSVGElement>) {
    return (
        <svg
            viewBox="0 0 19 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g opacity="0.7">
                <path
                    d="M9.30669 10.0911C11.6183 10.0911 13.4923 8.15441 13.4923 5.76536C13.4923 3.37631 11.6183 1.43961 9.30669 1.43961C6.99505 1.43961 5.12109 3.37631 5.12109 5.76536C5.12109 8.15441 6.99505 10.0911 9.30669 10.0911Z"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeMiterlimit="10"
                />
                <path
                    d="M1.57812 15.7066C3.12372 12.3531 6.00373 10.091 9.30613 10.091C12.6085 10.091 15.4885 12.3531 17.0341 15.7066"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                />
            </g>
        </svg>
    )
}
